<template>
    <card title="Unresolved Patient Cases">
        <template #header-right>
            <b-button v-if="$permissions.some(p => p.permissionCodeName === 'Admin/Case Question Sets')"
                variant="secondary" size="sm" v-b-modal.questionSetsModal>
                <i class="fa fa-gear"></i>
                Manage Question Sets
            </b-button>
        </template>
        <CasesListComponent show="opened" />

        <b-modal id="questionSetsModal" hide-footer no-fade title="Question Sets" size="lg">
            <TaskQuestionSets :entity-type="EntityType.Case" :default-scope-options="problems"
                default-scope-name="Case Type" />
        </b-modal>
    </card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import CasesListComponent from '@/components/Cases/CasesListComponent.vue';
import { EntityType } from '@/models/EntityType';
import TaskQuestionSets from '@/components/Tasks/TaskQuestionSets.vue';
import axios from 'axios';

@Component({
    name: "OpenedCasesPage",
    components: {
        CasesListComponent,
        TaskQuestionSets
    },
})
export default class OpenedCasesPage extends Vue {
    created() {
        this.getCaseProblems();
        console.log("%c Created OpenedCasesPage", "color: green");
    }

    beforeDestroy() {
        console.log('%c Destroying OpenedCasesPage', 'color: red');
    }

    EntityType = EntityType;

    protected problems: string[] = [];

    async getCaseProblems() {
        try {
            const resp = await axios.get<string[]>("/Case/problems");
            this.problems = resp.data;
        } catch (err) {
            console.error(err);
        }
    }

}
</script>

<style scoped></style>
